const CHAR_CODES = {
  COMMA: 44,
  DOT: 46,
  PLUS: 43,
  SPACE: 32,
  NUMBER_0: 48,
  NUMBER_9: 57,
  ENTER: 69,
  MINUS: 45,
};

const MAX_DECIMAL_POSITIONS = 2;

export default {
  allowPhoneNumber: (event: KeyboardEvent) => {
    const charCode: number = event.key.charCodeAt(0);
    if (
      charCode !== CHAR_CODES.PLUS &&
      charCode > CHAR_CODES.SPACE &&
      (charCode < CHAR_CODES.NUMBER_0 || charCode > CHAR_CODES.NUMBER_9)
    ) {
      event.preventDefault();
    }
  },
  allowOnlyNumeric: (event: KeyboardEvent) => {
    const charCode: number = event.key.charCodeAt(0);
    if (
      charCode !== CHAR_CODES.ENTER &&
      charCode >= CHAR_CODES.SPACE &&
      (charCode < CHAR_CODES.NUMBER_0 || charCode > CHAR_CODES.NUMBER_9)
    ) {
      event.preventDefault();
    }
  },
  allowOnlyDecimalNumbers: (event: KeyboardEvent, maxDecimals = MAX_DECIMAL_POSITIONS) => {
    const inputValue: string = (event.target as HTMLInputElement).value;

    if (inputValue) {
      if (inputValue.split('.')[1]?.length >= maxDecimals) {
        event.preventDefault();
      }
    }
    const charCode: number = event.key.charCodeAt(0);
    if (
      // prettier-ignore
      ![
        CHAR_CODES.ENTER,
        CHAR_CODES.DOT,
        CHAR_CODES.COMMA,
      ].includes(charCode) &&
      charCode >= CHAR_CODES.SPACE &&
      (charCode < CHAR_CODES.NUMBER_0 || charCode > CHAR_CODES.NUMBER_9)
    ) {
      event.preventDefault();
    }
  },
  allowOnlyDecimalNumbersWithMinus: (event: KeyboardEvent) => {
    const charCode: number = event.key.charCodeAt(0);
    if (
      // prettier-ignore
      ![
        CHAR_CODES.ENTER,
        CHAR_CODES.DOT,
        CHAR_CODES.COMMA,
        CHAR_CODES.MINUS,
      ].includes(charCode) &&
      charCode >= CHAR_CODES.SPACE &&
      (charCode < CHAR_CODES.NUMBER_0 || charCode > CHAR_CODES.NUMBER_9)
    ) {
      event.preventDefault();
    }
  },
};
